module.exports = "/assets/data/0db4ea1f1c382d9cd60056764f78d352-GU31.data.json";